import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useLayoutStyles = makeStyles((theme) =>
  createStyles({
    root: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    },

    grayColor: {
      backgroundColor: '#F8F8F8'
    },

    footer: {},

    main: {
      display: 'flex',
      marginTop: 64.5,
      backgroundColor: '#F5F5F5',
      flex: 1
    },

    redesignedLandingMain: {
      display: 'flex',
      marginTop: 64.5,
      backgroundColor: '#fff',
      flex: 1
    },

    mainContainer: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: 0,
      padding: 16,
      [theme.breakpoints.up('md')]: {
        padding: 24
      }
    },

    redesignedLandingMainContainer: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: 0,
      padding: 0
    },

    mainContainerWithoutSidebar: {
      flexDirection: 'column'
    },

    containerXl: {
      maxWidth: 1440,

      [theme.breakpoints.down(1440.5)]: {
        maxWidth: 1240
      }
    },

    content: {
      flex: 1,
      minWidth: 0
    },

    sidebar: {
      [theme.breakpoints.up('md')]: {
        paddingLeft: 16,
        marginLeft: 16
      }
    },

    leftColumnRoot: {
      width: '100%',
      marginBottom: theme.spacing(4),

      [theme.breakpoints.up('md')]: {
        width: 'auto',
        marginBottom: 0
      }
    },

    sticky: {
      [theme.breakpoints.up('md')]: {
        position: 'sticky',
        top: 88
      }
    },

    small: {
      [theme.breakpoints.up(960)]: {
        width: '100%',
        maxWidth: 350
      }
    },

    large: {
      [theme.breakpoints.up('md')]: {
        width: '100%',
        maxWidth: 450
      }
    },

    hidden: {
      display: 'none',
      marginBottom: 0,

      [theme.breakpoints.up(960)]: {
        display: 'block'
      }
    },

    backDrop: {
      background: 'rgba(255,255,255,0.2)'
    }
  })
)
